import { Bill } from '@features/bills/types/bill'
import { BillLine } from '@features/bills/types/billLine'

import { TaxMode } from '../../../../../enums/taxMode'

export const getInclVatAmount = (bill: Bill, billLine: Partial<BillLine>): number => {
  const amount = billLine.amount || 0
  const vatAmount = billLine.tax || 0

  return bill.taxMode === TaxMode.Excluding ? amount + vatAmount || 0 : amount
}
